import * as React from 'react';
import { Box, Card, CardContent, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ListItem } from '../types/dashboard.types';
import imagePaths from '../../conf/imageConfig';

interface DashboardListProps {
  title: string;
  items: ListItem[];
  emptyMessage: string;
  showDescription?: boolean;
}

const DashboardList: React.FC<DashboardListProps> = ({
  title,
  items,
  emptyMessage,
  showDescription = false,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Card sx={{ height: '300px', overflow: 'auto' }}>
      <CardContent>
        <Typography
          variant="h6"
          sx={{ color: '#515e8e', marginBottom: '12px', fontSize: { xs: '1rem', sm: '1.2rem' } }}
        >
          {title}
        </Typography>
        {items.length > 0 ? (
          items.map((item) => (
            <Box key={item.id} sx={{ display: 'flex', alignItems: 'center', py: 1 }}>
              <img
                src={item.avatar || imagePaths.user}
                alt="User Avatar"
                style={{
                  width: isSmallScreen ? '30px' : '40px',
                  height: isSmallScreen ? '30px' : '40px',
                  borderRadius: '50%',
                  backgroundColor: '#e0e0e0',
                  marginRight: '16px',
                }}
              />
              <Box>
                <Typography sx={{ fontSize: { xs: '0.9rem', sm: '1rem' } }}>
                  {item.name || item.username || 'Unnamed'}
                </Typography>
                {showDescription && (
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' } }}
                  >
                    {item.description || item.brief || item.amount || 'No description'}
                  </Typography>
                )}
              </Box>
            </Box>
          ))
        ) : (
          <Typography sx={{ color: 'textSecondary' }}>{emptyMessage}</Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default DashboardList;